import { modes } from "../modes";
import { permissions } from "../permissions/permissions";
import { roles } from "../roles";

export const remarketingPermissionProfiles = {
    VIEW_VEHICLE_GRADE: {
        [modes.EDIT]: [roles.OWNER],
        [modes.EDIT_PERMISSION]: [permissions.REMARKETING.VIEW_VEHICLE_GRADE],
    },
    VIEW_INTELLIGENCE_DASHBOARD: {
        [modes.EDIT]: [roles.OWNER],
        [modes.EDIT_PERMISSION]: [permissions.REMARKETING.VIEW_INTELLIGENCE_DASHBOARD],
    },
}
